<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_start')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.date_start"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_end')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.date_end"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_trader')}}</template>
                        <b-form-select v-model="ajaxSearch.trader">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.traderList" :key="index" :value='list'>{{list}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_status')}}</template>
                        <b-form-select v-model="ajaxSearch.status">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.withdrawStatusList" :key="index" :value='list.code'>{{list.name}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" @click="initialize()">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" v-for="(tabTitle,index) in ajaxTabTitle" :key="index">{{tabTitle.label}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(content,index) in ajaxTable" :key="index">
                            <td>{{content.Trader}}</td>
                            <td>{{content.VRT}}</td>
                            <td>{{content.BTC}}</td>
                            <td>{{content.ETH}}</td>
                            <td>{{content.USDT}}</td>
                            <td>{{content.LTC}}</td>
                            <td>{{content.BCHABC}}</td>
                            <td>{{content.DOGE}}</td>
                            <td>{{content.DASH}}</td>
                        </tr>
                    </tbody>
                </table>
                <b-col sm="12" md="12" class="pl-0">
                    <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                </b-col>
            </b-card>
        </div>
    </div>
</template>

<script>
import {traderWithdrawAjaxTable} from '@/system/model/transaction';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{  
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',trader:'',status:'',date_start:'',date_end:''},
            ajaxRow:'',
            pageLimit:10,
            ajaxToolList:[],
            ajaxTabTitle:[],       
        }
    },methods:{
        initialize(){
            var self = this;
            var result = traderWithdrawAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.trader,this.ajaxSearch.status,this.ajaxSearch.date_start,this.ajaxSearch.date_end);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTabTitle = value.data.tab_title;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
